module.exports = __webpack_public_path__ + "img/bmcl_gallery1.0cc27777.jpg";